import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "inner-menu" };
const _hoisted_2 = { class: "inner-menu__nav" };
const _hoisted_3 = ["href", "onClick"];
const _hoisted_4 = {
    key: 0,
    class: "js-show-more toggle-more"
};
const _hoisted_5 = {
    key: 1,
    class: "js-show-less toggle-more"
};
import Strings from "src/shared/Strings";
import { computed, ref } from "vue";
import { useSecondaryMenuParent } from "../composables";
import { useNavigationContext } from "../navigationContext";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SecondaryNavigationItem',
    props: {
        menuItems: {},
        currentPage: {},
        parentName: {}
    },
    setup(__props) {
        const { secondaryMenuParent } = useSecondaryMenuParent();
        const navigationContext = useNavigationContext();
        const props = __props;
        const isAllShown = ref(false);
        const isItemActive = (link) => {
            const currentPath = window.location.pathname;
            const normalizedLink = link.replace("#/", "");
            const normalizedCurrentPage = props.currentPage.replace("#/", "");
            // Check if this secondary menu should be active based on navigation context
            // If the current page was navigated to from a different parent menu, don't show as active
            if (secondaryMenuParent.value !== props.parentName) {
                return false;
            }
            // Check if any other menu item has an exact match first
            const hasExactMatch = props.menuItems.some((item) => {
                if (!item)
                    return false;
                const otherNormalizedLink = item.link.replace("#/", "");
                return (otherNormalizedLink === normalizedCurrentPage ||
                    otherNormalizedLink === currentPath);
            });
            // Check if there's a more specific (longer) match for prefix scenarios
            const hasMoreSpecificMatch = props.menuItems.some((item) => {
                if (!item || item.link === link)
                    return false;
                const otherNormalizedLink = item.link.replace("#/", "");
                return ((otherNormalizedLink === normalizedCurrentPage ||
                    otherNormalizedLink === currentPath) &&
                    otherNormalizedLink.length > normalizedLink.length);
            });
            // If there's a more specific match, don't show this as active
            if (hasMoreSpecificMatch) {
                return false;
            }
            // If there's an exact match somewhere, only return true for exact matches
            if (hasExactMatch) {
                return (normalizedLink === normalizedCurrentPage ||
                    normalizedLink === currentPath);
            }
            // Otherwise, fall back to prefix matching
            return (normalizedLink === normalizedCurrentPage ||
                normalizedLink === currentPath ||
                currentPath.startsWith(normalizedLink + "/"));
        };
        const computedMenuItems = computed(() => {
            if (isAllShown.value) {
                return props.menuItems;
            }
            return props.menuItems.slice(0, 10);
        });
        const setSecondaryMenuParent = (link) => {
            // Record the navigation context for secondary menu clicks
            navigationContext.recordNavigation({
                from: secondaryMenuParent.value,
                to: link,
                menuItem: props.parentName,
            });
            secondaryMenuParent.value = props.parentName;
        };
        const toggleNav = () => {
            isAllShown.value = !isAllShown.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedMenuItems.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: item.link
                        }, [
                            _createElementVNode("a", {
                                href: item.link,
                                class: _normalizeClass({
                                    active: isItemActive(item.link),
                                }),
                                onClick: ($event) => (setSecondaryMenuParent(item.link))
                            }, _toDisplayString(_unref(Strings).capitalize(item.text)), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
                        ]));
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_ctx.menuItems.length > 10 && computedMenuItems.value.length <= 10)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                            _createElementVNode("a", { onClick: toggleNav }, "See All")
                        ]))
                        : _createCommentVNode("v-if", true),
                    (computedMenuItems.value.length > 10)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                            _createElementVNode("a", { onClick: toggleNav }, "See Less")
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
